export default __webpack_public_path__ + "static/The Home_Image 4_carousel 2@2x-42d2fa3f669eac9d223a6d4a709bfc54.jpg";